export default function(pointA, pointB) {
  return pointA[0] === pointB[0] && pointA[1] === pointB[1];
}



//////////////////
// WEBPACK FOOTER
// ./~/topojson-server/src/hash/point-equal.js
// module id = 69
// module chunks = 0